<template>
  <div>
    <PageTitle
      title="Expense Setting Details"
      :backBtn="true"
      :editRoute="'/expensesetting/edit/' + this.$route.params.id"
      :permission="'Expense Setting Edit'"
    />

    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xs="12">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title"
                  ><v-icon color="blue" small>mdi-cog-outline</v-icon
                  ><span class="ml-3"> General </span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Expense for </v-row>
                          <v-row>
                            {{ ExpenseSettingList.expense_for }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Amount </v-row>
                          <v-row>
                            {{ ExpenseSettingList.amount | formatCurrency }}
                          </v-row>
                        </v-col>

                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Repeat </v-row>
                          <v-row>
                            {{ ExpenseSettingList.repeat }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Repeat End </v-row>
                          <v-row>
                            <v-icon small>mdi-calendar</v-icon>
                            {{
                              ExpenseSettingList.repeat_end
                                ? ExpenseSettingList.repeat_end
                                : null | formatDate
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Date </v-row>
                          <v-row>
                            <v-icon small>mdi-calendar</v-icon>
                            {{ ExpenseSettingList.date | formatDate }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Shop </v-row>
                          <v-row>
                            {{
                              ExpenseSettingList.shop
                                ? ExpenseSettingList.shop.name
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Warehouse </v-row>
                          <v-row>
                            {{
                              ExpenseSettingList.warehouse
                                ? ExpenseSettingList.warehouse.name
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Category </v-row>
                          <v-row>
                            {{
                              ExpenseSettingList.category.name
                                ? ExpenseSettingList.category.name
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- *************************************************************************
    SCRIPT
    ************************************************************************* -->
<script>
//COMPONENTS
import axios from '@/plugins/axios';
export default {
  data() {
    return {
      name: '',
      code: '',
      reference_number: '',
      addresses: '',
      contacts: '',
      maximum_credit_amount: '',
      payment_team: '',
      AccountDetails: '',

      ExpenseSettingList: [],
    };
  },
  components: {},
  methods: {
    GetExpenseSetting() {
      let expensesettingId = this.$route.params.id;

      axios
        .get(`settings/expense-settings/${expensesettingId}`)
        .then((res) => {
          this.ExpenseSettingList = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetExpenseSetting();
  },
};
</script>
<style scoped>
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.totalText {
  font-family: Roboto;
  font-size: 16px;
}
</style>
